import { MAX_PAGE_SIZE } from '@debbie/common/dist/index.js';
import { collectionEngineV1, drainPages } from '../apis.js';
const req = collectionEngineV1('/transaction-accounts');
export const create = (newTransactionAccount) => req('POST', `/`, {
    body: newTransactionAccount,
});
// Pages to the end so callers keep getting the full set.
export const getAll = () => drainPages((page) => req('GET', `/?page=${page}&pageSize=${MAX_PAGE_SIZE}`), MAX_PAGE_SIZE);
export const patch = (transactionAccountId, patch) => req('PATCH', `/${transactionAccountId}`, {
    body: patch,
});
export const del = (transactionAccountId) => req('DELETE', `/${transactionAccountId}`);
export const uploadFile = (transactionAccountId, upload) => req('POST', `/imports/${transactionAccountId}`, { body: upload });
export const getImportById = (transactionImportId) => req('GET', `/imports/${transactionImportId}`);
//# sourceMappingURL=transaction-accounts.js.map